var optedInValue = '1';
/**
 * Name of the cookie consent
 */

var cookieName = 'CONSENTMGR';
/**
 * Name of the cookie consent categories
 */

var categories = {
  performance: 'c1:',
  marketing: 'c3:'
};
/**
 * Get value of consent cookie
 * @param {string} cookies list of cookies
 * @param {string} cookieName name of the consent cookie based on brand, defaults to 'CONSENTMGR'
 * @returns {string} consent cookie value
 */

var getConsentCookieValue = function getConsentCookieValue(cookies) {
  var consentCookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cookieName;
  var newConsentCookie = cookies && cookies.split(';').filter(function (cookie) {
    return cookie.trim().startsWith("".concat(consentCookie, "="));
  });
  return newConsentCookie && newConsentCookie.length ? newConsentCookie[0].split('=')[1] : '';
};
/**
 * Get relevant consent section (e.g. c1 = performance, c3 = marketing) in cookie value
 * @param {string} cookieValue consent cookie value
 * @param {string} category cookie consent category name
 * @returns {array} cookie consent category section (name and value e.g 'c1:1')
 *
 * Example cookie value: 'c1:1|c2:0|c3:1|c4:0|c5:0|c6:0|c7:0|c8:0|c9:0|c10:0|c11:0|c12:0|c13:0|c14:0|c15:0|ts:1575020721807|consent:true'
 */


var getCategorySection = function getCategorySection(cookieValue, category) {
  return decodeURI(cookieValue).split('|').filter(function (section) {
    return section.trim().startsWith(categories[category]);
  });
};
/**
 * Check if user has opted in for a category
 * @param {array} categorySection cookie consent category section (Example category section: 'c1:1')
 * @returns {boolean} true if opted in / false if not opted in
 */


var hasOptedIn = function hasOptedIn(categorySection) {
  if (!categorySection) return false;
  var consentValue = categorySection.split(':')[1];
  return consentValue === optedInValue;
};

export default {
  cookieName: cookieName,
  categories: categories,
  getConsentCookieValue: getConsentCookieValue,
  getCategorySection: getCategorySection,
  hasOptedIn: hasOptedIn
};